import styled, { css } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';

export const FiltersWrapper = styled.div(
  props => css`
    display: flex;
    flex-direction: column;
    row-gap: ${layout.measurements.spacing050};

    ${media.mediumDown`
      margin: 0;
    `}
  `
);
